<template>
  <div id="notfound" class="mb-3">
    <div class="icon-notfound">
      <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50">
        <g id="Icon_50_Notfound" data-name="Icon/50/Notfound" transform="translate(0)">
          <path
            id="Shape"
            d="M25,50A25,25,0,1,1,50,25,25.029,25.029,0,0,1,25,50ZM8.085,9.557A22.9,22.9,0,0,0,40.442,41.916ZM25,2.084a22.844,22.844,0,0,0-15.443,6L41.916,40.442A22.9,22.9,0,0,0,25,2.084Z"
            transform="translate(50 0) rotate(90)"
            fill="#acadb1"
          />
        </g>
      </svg>
    </div>
    <div style="text-align: left">
      <h4>{{ $t('biblioSegment.noSearch') }}</h4>
      <h6>
        {{ $t('biblioSegment.trySearch') }}
      </h6>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFoundCard',
};
</script>

<style scoped>
#slide-list #notfound .card-body {
  display: flex;
}

#notfound {
  padding: 1em;
  display: flex;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.16), 2px 4px 6px rgba(0, 0, 0, 0.23);
}

.icon-notfound {
  display: flex;
  margin-right: 1em;
}
</style>



// WEBPACK FOOTER //
// NotFoundCard.vue?1174f0bc